var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffroad1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 60,
    viewBox: "0 0 112 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2763 13.1254L44.4476 4.56812C51.7345 2.68829 59.4426 3.32369 66.3233 6.37139L101.394 21.9054C102.398 22.3499 103.335 22.9301 104.181 23.6298C109.685 28.1853 110.004 36.5156 104.864 41.4786L95.612 50.4114C91.2346 54.6379 85.3874 57 79.3026 57H12.0614C6.45074 57 3.31611 50.5253 6.79604 46.1242C10.3246 41.6616 10.4586 35.3979 7.12414 30.7885L5.64519 28.7441C1.49562 23.0079 4.42102 14.8939 11.2763 13.1254Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffroad1);
export default __webpack_public_path__ + "static/media/offroad1.2f1bbd49.svg";
export { ForwardRef as ReactComponent };